import { AgingPeriodViewCacheStates } from '../states';

export const selectAgingPeriodCache = (state: AgingPeriodViewCacheStates) => state.agingPeriodViewCache.agingPeriod;
